module.exports = __webpack_public_path__ + "static/media/service.25302123.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/pins/service.svg
// module id = 1946
// module chunks = 0